module.exports = __webpack_public_path__ + "img/dan4.f9bb09bd.png";